import { useIaQuery } from '@develop/ia-api-library'
import type { PharmacyDetailsQuery } from '../models/generated/iade'
import { PharmacyDetails as PharmacyDetailsDocument } from '../models/generated/iade'
import type { PharmacyDetails } from '@/models/pharmacy-details'

export const fetchPharmacyDetails = async (pharmacyId: number) => {
  const response = await useIaQuery<PharmacyDetailsQuery>({ query: PharmacyDetailsDocument, variables: { pharmacyId } })
  const data = { ...response.data.value?.getPharmacyDetails, id: pharmacyId } as PharmacyDetails

  const isError = response.error.value != null
  const isNotFound = response.error.value?.message?.includes('not found') !== undefined

  return {
    data,
    success: !isError,
    status: isError ? (isNotFound ? 404 : 500) : 200,
    message: response.error.value?.message || null,
  }
}
